import { List, Page, PathButton } from "shared/react";
import { type CreatorEntity, FOLLOWING_MAX } from "shared/schema";
import { EntityHeader } from "../entity/EntityHeader.js";
import { useQuery } from "../util/db.js";
import { ProfileCard } from "./ProfileCard.js";
import { useProfileContext } from "./ProfileContext.js";
import { ProfileOwnerCondition } from "./ProfileOwnerCondition.js";

export function FollowersPage(): React.ReactElement {
	const profile = useProfileContext();
	const { id: uid } = profile;
	const entity: CreatorEntity = `profile:${uid}`;
	return (
		<Page>
			<EntityHeader entity={entity}>
				<h1>Followers</h1>
			</EntityHeader>
			<ProfileOwnerCondition uid={uid}>
				<section>
					<PathButton path="/requests">Follow requests</PathButton>
				</section>
			</ProfileOwnerCondition>
			<section>
				<List //
					store={useQuery("following", { followed: uid, status: "approved", $order: "!updated", $limit: FOLLOWING_MAX })}
					mapper={({ follower }) => <ProfileCard key={follower} uid={follower} />}
					more="Show more followers"
					empty="No followers"
				/>
			</section>
		</Page>
	);
}
